import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
import { AlertModal } from 'plankton'
import { initServices } from './global-setup/services'
import { sendErrorToSentry } from './global-setup/sentry'
import handleGlobalError from './global-setup/handle-global-error'
import {
  registerGlobalComponents,
  registerPlugins,
  registerMixins,
  registerFilters
} from './global-setup/global-vue-setup'
import registerGoogleMaps from './global-setup/register-google-maps'
import App from './App.vue'
import router from './router'
import store from './store'
import DirectionsMap from './components/DirectionsMap.vue'
import { i18n } from './plugins/i18n'

// Import external styles
import 'sweetalert2/dist/sweetalert2.min.css'
import 'plankton/dist/plankton.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

// Import local orcas styles
import './styles/main.scss'
import { AxiosError } from 'axios'

Vue.config.productionTip = false

registerPlugins()
registerFilters()
registerMixins()
Vue.use(VueSweetalert2)
registerGlobalComponents()
registerGoogleMaps(Vue)
Vue.component('DirectionsMap', DirectionsMap)

initServices()
Vue.config.errorHandler = (error, vm) => {
  // NOTE: the global error handler won't catch errors in async callback functions (see
  // https://github.com/vuejs/vue/issues/7653). Use $emit instead or wrap async call in try/catch.
  try {
    handleGlobalError(error as AxiosError, AlertModal(Vue.swal))
  } catch (err) {
    sendErrorToSentry(err, vm)
  }
}

window.onunhandledrejection = function(promiseRejection) {
  handleGlobalError(promiseRejection.reason, AlertModal(Vue.swal))
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
